import { render, staticRenderFns } from "./SectionMacro.vue?vue&type=template&id=171bbe18&scoped=true&"
import script from "./SectionMacro.vue?vue&type=script&lang=js&"
export * from "./SectionMacro.vue?vue&type=script&lang=js&"
import style0 from "./SectionMacro.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./SectionMacro.vue?vue&type=style&index=1&id=171bbe18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "171bbe18",
  null
  
)

export default component.exports